import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { MasterService } from 'src/app/services/master.service';

import { MapMarkerDialogComponent } from './../map-marker-dialog/map-marker-dialog.component';

import { BusinessType, District, Province, Regency, RegisterContent, Village } from 'src/app/models/master';
import { RegisterCompanyRequest } from 'src/app/models/account';

import * as _ from 'lodash';

@Component({
  selector: 'app-register-business-form',
  templateUrl: './register-business-form.component.html',
  styleUrls: ['./register-business-form.component.css']
})
export class RegisterBusinessFormComponent implements OnInit {
  @Input()
  data: RegisterCompanyRequest;
  @Input()
  businessTypes: BusinessType[];
  @Input()
  provinces: Province[];
  @Input()
  submitting: boolean;

  @Output() onNextStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrevStep: EventEmitter<any> = new EventEmitter<any>();
  
  stepName: string = "business-profile";
  regencies: Regency[] = [];
  districts: District[] = [];
  villages: Village[] = [];
  postalCodes: string[] = [];
  numberOnlyPattern: object[];

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private masterService: MasterService
  ) {
    // init number only pattern
    let numberOnlyPattern = [];
    for (let i = 0; i < 250; i++) {
      numberOnlyPattern.push(/\d/);
    }
    this.numberOnlyPattern = numberOnlyPattern;
  }

  ngOnInit() {
  }

  nextStep(isValid:boolean) {
    if(isValid){
      this.onNextStep.emit({
        step: this.stepName,
        data: this.data,
      });
    } else {
      this.toastr.error('Terdapat data yang belum lengkap, mohon periksa kembali.', '', {
        timeOut: 3000
      });
    }
  }

  onImageChanged(files: FileList): void {
    if (files.length > 0) {
      const file = files.item(0);
      this.data.image_name = file.name;
      this.data.image = file;
    }
  }

  openMapMarker() {
    const modalRef = this.modalService.open(MapMarkerDialogComponent, {ariaLabelledBy: 'modal-basic-title', size: 'lg', centered: true, windowClass: "register-information-dialog", backdrop: 'static'});
    if (this.data.coordinate) {
      let coordinate = this.data.coordinate.split(",");
      if(coordinate.length === 2) {
        modalRef.componentInstance.latitude = parseFloat(coordinate[0]);
        modalRef.componentInstance.longitude = parseFloat(coordinate[1]);
      }
    }

    modalRef.result.then((result) => {
      this.data.coordinate = `${result.latitude || 0},${result.longitude || 0}`;
    }, function dismiss() {})
  }

  onProvinceChanged() {
    let provinceID = this.data.province_id;
    this.data.regency_id = undefined;
    this.data.district_id = undefined;
    this.data.village_id = undefined;
    this.data.postal_code = undefined;
    this.regencies = [];
    this.districts = [];
    this.villages = [];
    this.postalCodes = [];
    this.masterService.getRegencies(
      provinceID,
      (data) => {
        this.regencies = data;
      },
      (err) => {
        console.log(err);
      });
  }

  onRegencyChanged() {
    let regencyID = this.data.regency_id;
    this.data.district_id = undefined;
    this.data.village_id = undefined;
    this.data.postal_code = undefined;
    this.districts = [];
    this.villages = [];
    this.postalCodes = [];
    this.masterService.getDistricts(
      regencyID,
      (data) => {
        this.districts = data;
      },
      (err) => {
        console.log(err);
      });
  }

  onDistrictChanged() {
    let districtID = this.data.district_id;
    this.data.village_id = undefined;
    this.data.postal_code = undefined;
    this.villages = [];
    this.postalCodes = [];
    this.masterService.getVillages(
      districtID,
      (data) => {
        this.villages = data;
      },
      (err) => {
        console.log(err);
      });
  }

  onVillageChanged() {
    let districtID = this.data.district_id;
    let village = this.villages.find((value) => value.villageId === this.data.village_id);
    this.data.postal_code = undefined;
    this.postalCodes = [];
    this.masterService.getPostalCodes(
      districtID,
      village.villageName,
      (data) => {
        let postCodes = [];
        data.forEach((value) => {
          if (value.postCode !== "") {
            postCodes.push(value.postCode);
          }
        });
        this.postalCodes = _.uniq(postCodes);
      },
      (err) => {
        console.log(err);
      });
  }

}
